import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../environments/environment';
import { version } from '../../package.json';

class DataDogConfig {
    public init() {
        if (!environment.dataDogApplicationId || !environment.dataDogClientToken) {
            return;
        }

        datadogRum.init({
            applicationId: environment.dataDogApplicationId,
            clientToken: environment.dataDogClientToken,
            // `site` refers to the Datadog site parameter of your organization
            // see https://docs.datadoghq.com/getting_started/site/
            site: 'datadoghq.com',
            service: environment.dataDogService,
            env: environment.dataDogEnvironment,
            // Specify a version number to identify the deployed version of your application in Datadog
            version: version,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask-user-input',
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
        });
    }

    public captureError(e: Error, context?: Record<string, any>) {
        datadogRum.addError(e, context);
    }

    public captureWarning(e: Error) {
        datadogRum.addAction('warning', {
            message: 'Custom warning',
            stack: e.stack,
        });
    }
}

export default new DataDogConfig();
